<template>
  <GbwapsLayout title="GB WhatsApp Old Versions" :intro="pageIntro" :breadcrumb="breadcrumb">
    <div class="old-version-page">
      <section
        v-for="section in sections"
        :id="section.id"
        :key="section.id"
        class="page-section site-section"
      >
        <h2>{{ section.h2 }}</h2>
        <ContentBlocks :blocks="section.blocks" />

        <table v-if="section.layout === 'version-table'" class="version-table">
          <thead>
            <tr>
              <th>Version</th>
              <th>Size</th>
              <th>Android</th>
              <th>Release Date</th>
              <th>Notes</th>
              <th>Download</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in versionRows" :key="row.version">
              <td>
                <code>{{ row.version }}</code>
                <span v-if="row.isCurrent" class="version-badge">Latest</span>
              </td>
              <td>{{ row.size }}</td>
              <td>{{ row.android }}</td>
              <td>{{ row.releaseDate }}</td>
              <td>{{ row.note }}</td>
              <td>
                <router-link to="/download/" class="btn-secondary btn-sm">
                  {{ row.isCurrent ? 'Download latest' : 'Download hub' }}
                </router-link>
              </td>
            </tr>
          </tbody>
        </table>

        <table v-if="section.layout === 'old-vs-new-table'" class="comparison-table old-vs-new-table">
          <thead>
            <tr>
              <th>Aspect</th>
              <th>Older builds (17.x)</th>
              <th>Current (18.80)</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="row in compareRows" :key="row.aspect">
              <td>{{ row.aspect }}</td>
              <td>{{ row.oldVer }}</td>
              <td>{{ row.newVer }}</td>
            </tr>
          </tbody>
        </table>
      </section>
    </div>
  </GbwapsLayout>
</template>

<script>
import '@/css/gbwaps/pages.css';
import GbwapsLayout from '@/layouts/GbwapsLayout.vue';
import ContentBlocks from '@/components/gbwaps/ContentBlocks.vue';
import {
	OLD_VERSION_SECTIONS,
	OLD_VERSION_ROWS,
	OLD_VS_NEW_ROWS,
} from '@/data/old-version-content';

export default {
  name: 'OldVersionPage',
  components: { GbwapsLayout, ContentBlocks },
  data() {
    return {
      pageIntro:
        'Download old and stable GB WhatsApp APK builds for compatibility, compare risks, and know when to stay on the latest version.',
      breadcrumb: [{ name: 'Home', to: '/' }, { name: 'Old Versions' }],
      sections: OLD_VERSION_SECTIONS,
      versionRows: OLD_VERSION_ROWS,
      compareRows: OLD_VS_NEW_ROWS,
    };
  },
};
</script>
